import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { format } from 'date-fns';

interface EndDateFilter {
  isDisabled?: boolean;
  onChange: (type: any, value: any) => void;
}

export const EndDateFilter = ({ isDisabled, onChange }: EndDateFilter) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker disabled={isDisabled}
        onChange={(date: any) => onChange("toDate", format(new Date(date), 'MM/dd/yyyy'))}
        slotProps={{ textField: { size: 'small', label: `End Date`, fullWidth: true } }}
        sx={{ width: '100%' }}
      />
    </LocalizationProvider>
  )
}